import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import PostListSource from './PostListSource';
import { relatedId } from './realtimeEvents';

/**
 * The newest replies in one discussion. Core's PostStream is bound to window
 * scrolling and can't live in a column, so this is a newest-first post list
 * with a link through to the real discussion page.
 */
export default class DiscussionPostsSource extends PostListSource {
  constructor(discussionId) {
    super({
      filter: {
        discussion: discussionId
      }
    });
    this.discussionId = discussionId;
  }
  matches(post) {
    return relatedId(post, 'discussion') === this.discussionId;
  }

  /** A new discussion is never this one. */
  mayMatchNewDiscussion() {
    return false;
  }
  discussion() {
    return app.store.getById('discussions', this.discussionId);
  }
  prepare() {
    return this.discussion() ? Promise.resolve() : app.store.find('discussions', this.discussionId).catch(() => null);
  }
  view() {
    const discussion = this.discussion();
    return m('[', null, discussion && m(Link, {
      className: "Button Button--block DeckColumn-open",
      href: app.route.discussion(discussion)
    }, app.translator.trans('flarum-deck.forum.column.open_discussion_button')), super.view());
  }
}
flarum.reg.add('flarum-deck', 'forum/columns/DiscussionPostsSource', DiscussionPostsSource);